import { render, staticRenderFns } from "./BukuBesar.vue?vue&type=template&id=dc5f012e"
import script from "./BukuBesar.vue?vue&type=script&lang=js"
export * from "./BukuBesar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports